import { jsxs as l, jsx as C } from "react/jsx-runtime";
const i = () => /* @__PURE__ */ l(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C("rect", { width: "18", height: "18", rx: "6", fill: "var(--plac-lines-default)" }),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 4.5C3 3.67157 3.67157 3 4.5 3H6.5C6.77614 3 7 3.22386 7 3.5C7 3.77614 6.77614 4 6.5 4H4.5C4.22386 4 4 4.22386 4 4.5V13.5C4 13.7761 4.22386 14 4.5 14H13.5C13.7761 14 14 13.7761 14 13.5V11.5C14 11.2239 14.2239 11 14.5 11C14.7761 11 15 11.2239 15 11.5V13.5C15 14.3284 14.3284 15 13.5 15H4.5C3.67157 15 3 14.3284 3 13.5V4.5ZM14 4.70711L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536C7.45118 10.1583 7.45118 9.84171 7.64645 9.64645L13.2929 4H10.5C10.2239 4 10 3.77614 10 3.5C10 3.22386 10.2239 3 10.5 3H14.5C14.7761 3 15 3.22386 15 3.5V7.5C15 7.77614 14.7761 8 14.5 8C14.2239 8 14 7.77614 14 7.5V4.70711Z",
          fill: "var(--plac-primary-gray)"
        }
      )
    ]
  }
);
export {
  i as ChipGoToIcon
};
//# sourceMappingURL=index.es5598.js.map
